import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import Cache from 'i18next-localstorage-cache';
import LanguageDetector from 'i18next-browser-languagedetector';

const urlParams = location.search.split(/[?&]/).slice(1).map(function(paramPair) {
    return paramPair.split(/=(.+)?/).slice(0, 2);
}).reduce(function (obj, pairArray) {
    obj[pairArray[0]] = pairArray[1];
    return obj;
}, {});
let debug = false
try {
    const textLoader = urlParams.textLoader
    debug = textLoader != null && textLoader == 'true' ? true : false
}catch(err){console.log(err)}


let host = '/'
try{
    // Fix: Added null checks to prevent "Cannot read properties of undefined (reading 'host')"
    const $el = $('#js-dealcalendar-search');
    if ($el.length > 0) {
        const data = $el.data();
        if (data && data.host !== undefined) {
            host = data.host + '/';
        }
    }
}catch( err )
{
    // console.log( 'i18next path error', err ) // Debug log commented out
}


// console.log( "i18next host", host ) // Debug log commented out
i18n.use(XHR).use(Cache).use(LanguageDetector)
    .init({
        backend: {
            method: 'GET',
            mode: 'cors',
            cache: 'default',
            loadPath:  host + 'locales/{{lng}}/{{ns}}.json',
        },
        detection: {
            order: ['htmlTag'],
            htmlTag: document.html
        },
        fallbackLng: 'de',
        keySeparator: '#',
        ns: ['jetbeds'],
        defaultNS: 'jetbeds',
        debug: debug,
        interpolation: {
            escapeValue: false
        },
        withRef: true,
        translateFuncName: 't',
        wait: true,
        initImmediate: true,
    }, function (err) {
        if ( err === 'undefined' )
            console.log(err)
        else
            console.log("I18next loaded" )
    });


export default i18n;


// WEBPACK FOOTER //
// ./shared/I18next.jsx